import { post, get, put } from "@/utils/request";
import qs from "qs";
/**
 * 用户登录
 * @param params 表单参数 { username, password, operation_backend_pc, sign }
 * @param code 验证码/随机标识
 * @returns 返回 data 字段：{ access_token }
 */
export function login(params: any, code: string, randomStr: string) {
  const dataObj = qs.stringify(params);
  return post("/auth/oauth/token", dataObj, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      isToken: false,
      "TENANT-ID": "1",
      Authorization: "Basic c3VwcGxpZXI6c3VwcGxpZXI=",
    },
    params: {
      randomStr,
      code,
      grant_type: "password",
    },
  });
}

/**
 * 获取当前登录用户信息
 * @returns 用户信息 data 字段：{ sysUser, firstLogin, ... }
 */
export function getUserInfo(data: any) {
  return get("/admin/user/info", { params: data });
}

export function editUserInfo(data: any) {
  return put("/admin/adminUser/edit", data);
}
